import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const deactivateComment = async (reportedCommentId: string) => {
  const [response, bodyOrError] = await Api.patch(`comments/${reportedCommentId}/deactivate-comment`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useDeactivateReportedComment = () => {
  const queryClient = useQueryClient();
  return useMutation(
    'deactivateComment',
    (data: { reportedCommentId: string }) => {
      return deactivateComment(data.reportedCommentId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getReportedCommentById']);
        queryClient.invalidateQueries('reportedComments');
      },
    },
  );
};
